'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _calculateUnseenThreadsCount = require('../../threads/selectors/calculateUnseenThreadsCount');

var _getColoring = require('../../selectors/widgetDataSelectors/getColoring');

var _getIsOpen = require('../../selectors/getIsOpen');

var _getShowLauncherBadge = require('../../visitor-widget/selectors/getShowLauncherBadge');

var _Launcher = require('conversations-internal-components/visitor-widget/Launcher');

var _Launcher2 = _interopRequireDefault(_Launcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    badgeNumber: (0, _calculateUnseenThreadsCount.calculateUnseenThreadsCount)(state),
    coloring: (0, _getColoring.getColoring)(state),
    open: (0, _getIsOpen.getIsOpen)(state),
    showBadge: (0, _getShowLauncherBadge.getShowLauncherBadge)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_Launcher2.default);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/launcher/container/LauncherContainer.js
// module id = 1181
// module chunks = 2 3